import { register } from 'swiper/element/bundle';

/**
 * Registers Swiper web components globally.
 * Should be called once during app initialization.
 */
export function registerSwiperElements(): void {
  register();
}
